module.exports = __webpack_public_path__ + "static/img/bushes-before.46dc027.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/bushes-before.png
// module id = 651
// module chunks = 64